export const Placeholder = () => {
  return (
    <article
      className="mw-skeleton-card"
      data-testid="mw-loading-skeleton"
      aria-hidden="true"
    >
      <div className="mw-skeleton-header">
        <span className="mw-skeleton-shape mw-skeleton-avatar" />
        <div className="mw-skeleton-meta">
          <span className="mw-skeleton-shape mw-skeleton-line mw-skeleton-line--name" />
          <span className="mw-skeleton-shape mw-skeleton-line mw-skeleton-line--subtle" />
        </div>
        <span className="mw-skeleton-shape mw-skeleton-dot" />
      </div>

      <div className="mw-skeleton-body">
        <span className="mw-skeleton-shape mw-skeleton-line mw-skeleton-line--wide" />
        <span className="mw-skeleton-shape mw-skeleton-line mw-skeleton-line--medium" />
        <span className="mw-skeleton-shape mw-skeleton-media" />
      </div>

      <div className="mw-skeleton-actions">
        <span className="mw-skeleton-shape mw-skeleton-pill" />
        <span className="mw-skeleton-shape mw-skeleton-pill" />
        <span className="mw-skeleton-shape mw-skeleton-pill mw-skeleton-pill--short" />
      </div>
    </article>
  );
};
